import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth-context";

export default function ProtectedRoute({ children, role }) {
  const { user, checked } = useAuth();
  const location = useLocation();
  if (!checked) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center text-ink-muted font-sans">
        Loading…
      </div>
    );
  }
  if (!user) return <Navigate to={`/login?next=${encodeURIComponent(location.pathname + location.search)}`} replace />;
  if (role && user.role !== role) return <Navigate to="/dashboard" replace />;
  // Force MFA enrolment for every signed-in user before they can use the portal
  if (user.mfa_enabled === false && location.pathname !== "/mfa-setup") {
    return <Navigate to="/mfa-setup" replace />;
  }
  return children;
}
